import React from "react";
import BlogPostCard from "./BlogPostCard";

const PostsList = ({ edges }) => (
  <ul style={{ margin: 0 }} className="divide-y">
    {(edges || []).map(({ node }) => {
      const {
        id,
        excerpt,
        frontmatter: {
          title,
          category,
          date,
          featured_image: { thumbnail },
        },
        fields: { slug },
      } = node;

      return (
        <BlogPostCard
          key={id}
          title={title}
          thumbnail={thumbnail}
          slug={slug}
          excerpt={excerpt}
          date={date}
          category={category}
        />
      );
    })}
  </ul>
);

export default PostsList;
